
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import Model from '@/components/Model.vue'

export default defineComponent({
    components: {
        Model
    },
    setup() {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $useRoute = useRoute();
        const isLoading = ref<boolean>(true)
        const infoData = ref<any>({})
        const modelData = ref<any>(null)
        const type = ref<string>('one')
        const infoFlag = ref<boolean>(false)
        //该页面只会在app内展示
        // 判断用户是否登录
        const onLogin = () => {
            // let urlId = COVER.getUrl('id')
            // type.value = urlId == 1 ? 'one' : (urlId == 2 ?'two':(urlId == 3 ?'three':(urlId == 4 ?'four':'default')))
            if(COVERAPP.Attribute.isApp()){
                // console.log('当前链接',window.location.href)
                COVERAPP.Method.GetUser({
                    callback: function (user) {
                        user = JSON.parse(user);   
                        // console.log('已经登录，获取到的用户信息',user)        
                        if(user.token){
                            COVERAPP.Method.generateSign(user.token,{
                                callback: function (signData) {
                                    signData = JSON.parse(signData);
                                    // console.log('已经登录，获取用户验签',signData);
                                    getMyCollectionInfo(signData);//单纯拿信息
                                }
                            })
                        }else{//去登录
                            COVERAPP.Method.OpenLogin({ 
                                callback:function(user1){
                                    user1 = JSON.parse(user1);
                                    // console.log('重新登录，获取用户信息',user1)  
                                    if(user1.token){//登录之后再判断再拿一遍用户信息，改变按钮状态
                                        COVERAPP.Method.generateSign(user1.token,{
                                            callback: function (signData) {
                                                signData = JSON.parse(signData);
                                                // console.log('重新登录，获取用户验签',signData);
                                                getMyCollectionInfo(signData);//单纯拿信息
                                            }
                                        })
                                    }else{
                                        console.log('登录失败')   
                                    }
                                }
                            });
                        }
                    }
                });
            }else{
               getMyCollectionInfo({});//单纯拿信息 
            }
            
        }
        // 获取藏品信息
        const getMyCollectionInfo = (signData) => {
            let params;
            if(signData){
                params = {
                    token: signData.token,
                    vno:'7.4.0',
                    account:signData.account,
                    sign:signData.sign,
                    timestamp:signData.timestamp,
                    deviceid:signData.device_id,
                    data:JSON.stringify({id: $useRoute.query.id})
                }
            }else{
                params = {
                    data:JSON.stringify({id:$useRoute.query.id})
                }
            }
            
            _this.proxy.$http('/collection/myInfo', params
            , 'get').then((data: any) => {
                if (data) {
                    if(data.name && data.name.length>10){
                        data.name = data.name.substring(0,10)
                    }
                    if(data.set_name && data.set_name.length>10){
                        data.set_name = data.set_name.substring(0,10)
                    }
                    infoData.value = data
                    modelData.value = {
                        modelId: $useRoute.query.id,
                        url:  data.model_url || 'https://testcdn.thecover.cn/o_1fptoq7pfkve49g168k4d01272j.fbx',
                        color: 0xe7e4d8,
                        lightIntensity: $useRoute.query.id === '3' ? .5 : 0.7 // 调整id为3的光亮度
                    }
                    // console.log('value',data)
                    // console.log('infoData',infoData.value)
                    // console.log('modelData',modelData.value)
                    share(data.share || {})
                }else{
                    share({})
                }
                COVER.pageLoaded()
            }).catch(() => {
                share({})
                COVER.pageLoaded()
            })               
        }
        //分享
        const share = (data: any) => {
            let sharedata = {
                'title': data.share_title || '封面新闻',
                'link': data.share_url || window.location.href,
                'imgUrl': data.share_img || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                'desc': data.share_brief || ''
            };
            COVER.onshare(sharedata)
        }
        const loaded = () => {
            isLoading.value = false
        }
        // 打开链上信息
        const openInfo = () => {
            infoFlag.value = !infoFlag.value 
        }

        // 复制
        const copy = (data) => {
            if(!data){
                return;
            }
            // 存储传递过来的数据
            let OrderNumber = data;
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement("input");
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber;
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput);
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select();
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand("Copy");
            // 清空输入框
            newInput.remove();
            COVER.toast('复制成功')
        }

        onLogin ()
        onMounted(() => {
            // 埋点-新埋点
            COVER.trackNew('pageload', 0, COVER.getUrl('id'))
        })

        onBeforeUnmount(() => {
            
        })
        

        return {
            isLoading,
            infoData,
            modelData,
            loaded,
            type,
            infoFlag,
            openInfo,
            copy
        }
    }
})
